import { useCallback } from 'react';
import screenfull from 'screenfull';

import { telemetryNoticeError } from './useTelemetry';

type GoFullScreenProps = {
  elem?: HTMLElement | Element;
  hideNavigation: boolean;
};
const useFullScreen = () => {
  const goFullScreen = useCallback((props?: GoFullScreenProps | undefined) => {
    if (screenfull.isEnabled) {
      if (props?.elem)
        screenfull
          .request(props.elem, {
            navigationUI: props.hideNavigation ? 'hide' : 'auto',
          })
          .catch(error => {
            telemetryNoticeError(error, 'Error while trying to go full screen');
          });
      screenfull
        .request(undefined, {
          navigationUI: props?.hideNavigation ? 'hide' : 'auto',
        })
        .catch(error => {
          telemetryNoticeError(
            error,
            'Error while trying to go full screen without an element',
          );
        });
    }
  }, []);

  const closeFullScreen = useCallback(async (onSuccess?: () => void) => {
    screenfull
      .exit()
      .catch(err => {
        telemetryNoticeError(err, 'Error while trying to exit full screen');
      })
      .then(() => {
        onSuccess && onSuccess();
      });
  }, []);

  const toggleFullScreen = useCallback(
    (props?: GoFullScreenProps | undefined) => {
      if (screenfull.isFullscreen) {
        closeFullScreen();
      } else {
        goFullScreen(props);
      }
    },
    [goFullScreen, closeFullScreen],
  );

  return {
    isFullScreen: screenfull.isFullscreen,
    goFullScreen,
    closeFullScreen,
    toggleFullScreen,
  };
};

export default useFullScreen;
